import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getSXWYZS } from "../../../api/userApi";
import { T_SXWY_ZS } from "../../../app/privileges";
import { selectUserPrivileges } from "../../../app/user/userSlice";
import Loading from "../../component/Loading";
import RoleLayout from "../../component/RoleLayout";
import './SXWYZSPage.css';

const shengxiaoArr = ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪'];

export default function SXWYZSPage() {
    document.title = '十二生肖密码 终身'
    const [loading, setLoading] = useState(false)
    const [shengxiao, setShengxiao] = useState(-1)
    const [detail, setDetail] = useState()
    const hadPrivileges = useSelector(selectUserPrivileges)

    const chooseShengxiao = (index) => {
        if (loading) return
        setLoading(true)
        setDetail([])
        if (hadPrivileges.includes(T_SXWY_ZS)) {
            getSXWYZS(shengxiaoArr[index])
                .then(res => {
                    setDetail(res.data.description)
                })
                .catch(e => {
                    setDetail('无结果')
                })
                .finally(() => {
                    setShengxiao(index);
                    setLoading(false)
                })
        } else {
            setShengxiao(index);
            setLoading(false)
        }
    }

    return (
        <RoleLayout>
            <Container className="sxwyBackground">
                <Row>
                    <Col className='textBig g-0 d-flex justify-content-center'>
                        <span>十二生肖密码【仅供参考】</span>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>选择您的生肖属相</h2>
                    </Col>
                </Row>
                <Row className="marginLine">
                    {shengxiaoArr.map((i, index) => {
                        if (shengxiao >= 0 && index === shengxiao) {
                            return <Col key={index} xs={3} className='d-flex justify-content-center align-items-center'>
                                <div className="choosedBlock d-flex justify-content-center align-items-center"
                                    onClick={() => chooseShengxiao(index)} >
                                    <span>{i}</span>
                                </div>
                            </Col>
                        } else {
                            return <Col key={index} xs={3} className='d-flex justify-content-center align-items-center'>
                                <div className="chooseBlock d-flex justify-content-center align-items-center"
                                    onClick={() => chooseShengxiao(index)} >
                                    <span>{i}</span>
                                </div>
                            </Col>
                        }
                    }
                    )}
                </Row>
                {loading && <Loading/>}
                {!loading && detail &&
                    <div className="resultBlock">
                        <Row >
                            <Col className='d-flex justify-content-center align-items-center'>
                                {detail}
                            </Col>
                        </Row>
                    </div>
                }
            </Container>
        </RoleLayout>
    )
}